// Build petitioner/respondent names and advocate lists from NCLT partyDetails.
//
// NCLT party_type follows the pattern P1, P2, P3... (petitioners) and R1, R2, R3...
// (respondents). To mirror the "Add Case" model:
//   - P1 => main petitioner, P2/P3... => other petitioners (allPetitioners)
//   - R1 => main respondent, R2/R3... => other respondents (allRespondents)
//   - the same split applies to each party's advocate_name.
//
// `fallbackPetitioner` / `fallbackRespondent` come from parsing the "X VS Y" header
// and are only used when partyDetails has no usable entries.
export function buildNcltParties(partyDetails, fallbackPetitioner = "", fallbackRespondent = "") {
  const pd = Array.isArray(partyDetails) ? partyDetails : [];

  const clean = (v) => {
    const s = (v || "").trim();
    return s && s.toUpperCase() !== "NA" ? s : "";
  };

  // Preserve declared order (P1, P2... / R1, R2...) by sorting on the numeric suffix.
  const typeIndex = (t) => {
    const m = (t || "").match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  };

  const petitionerParties = pd
    .filter((p) => (p.party_type || "").toUpperCase().startsWith("P"))
    .sort((a, b) => typeIndex(a.party_type) - typeIndex(b.party_type));
  const respondentParties = pd
    .filter((p) => (p.party_type || "").toUpperCase().startsWith("R"))
    .sort((a, b) => typeIndex(a.party_type) - typeIndex(b.party_type));

  const petitionerNames = petitionerParties.map((p) => clean(p.party_name)).filter(Boolean);
  const respondentNames = respondentParties.map((p) => clean(p.party_name)).filter(Boolean);
  const petitionerAdvNames = petitionerParties.map((p) => clean(p.advocate_name)).filter(Boolean);
  const respondentAdvNames = respondentParties.map((p) => clean(p.advocate_name)).filter(Boolean);

  return {
    petitionerName: petitionerNames[0] || (fallbackPetitioner || "").trim() || "—",
    respondentName: respondentNames[0] || (fallbackRespondent || "").trim() || "—",
    allPetitioners: petitionerNames.map((name) => ({ name })),
    allRespondents: respondentNames.map((name) => ({ name })),
    petitionerAdvocate: petitionerAdvNames[0] || "",
    respondentAdvocate: respondentAdvNames[0] || "",
    allPetitionerAdvocates: petitionerAdvNames.map((name) => ({ name })),
    allRespondentAdvocates: respondentAdvNames.map((name) => ({ name })),
  };
}
